<div class="text-center p-4 rounded-t-2xl" style="background-color: #FFBE00;">
    <h1><b> Input Error Detected</b></h1>
</div>

<div class="grid grid-cols-2 gap-2 items-center py-6 px-4 w-full">
    <ng-container *ngIf="errorList.header">
        <div class="col-span-2 text-center">
            Header
        </div>

        <ng-container *ngFor="let header of errorList.header">
            <ng-container *ngIf="header.InjectionRateMmscfD">
                <div class="col-span-2" style="color: red;">
                    Injection Rate
                </div>
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of header.InjectionRateMmscfD">
                            <div class="mb-1">- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="header.ProductionRateBblDay">
                <div class="col-span-2" style="color: red;">
                    Production Rate
                </div>
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of header.ProductionRateBblDay">
                            <div class="mb-1">- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="header.ShutInTimeHrs">
                <div class="col-span-2" style="color: red;">
                    Shut - in time
                </div>
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of header.ShutInTimeHrs">
                            <div class="mb-1">- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="header.Tester">
                <div class="col-span-2" style="color: red;">
                    Tester
                </div>
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of header.Tester">
                            <div class="mb-1">- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="header.Date">
                <div class="col-span-2" style="color: red;">
                    Date
                </div>
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of header.Date">
                            <div class="mb-1">- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="header.GasLiftedHeader">
                <div class="col-span-2" style="color: red;">
                    Gas Lift Header
                </div>
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of header.GasLiftedHeader">
                            <div class="mb-1">- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="header.GasLiftedHeader">
                <div class="col-span-2" style="color: red;">
                    Gas Lift Header
                </div>
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of header.GasLiftedHeader">
                            <div class="mb-1">- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="header.Fthp">
                <div class="col-span-2" style="color: red;">
                    FTHP
                </div>
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of header.Fthp">
                            <div class="mb-1">- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="header.Sithp">
                <div class="col-span-2" style="color: red;">
                    SITHP
                </div>
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of header.Sithp">
                            <div class="mb-1">- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="header.Pcp">
                <div class="col-span-2" style="color: red;">
                    PCP
                </div>
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of header.Pcp">
                            <div class="mb-1">- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="header.Icp">
                <div class="col-span-2" style="color: red;">
                    ICP
                </div>
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of header.Icp">
                            <div class="mb-1">- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="header.Scp">
                <div class="col-span-2" style="color: red;">
                    SCP
                </div>
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of header.Scp">
                            <div class="mb-1">- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="header.Ccp">
                <div class="col-span-2" style="color: red;">
                    CCP
                </div>
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of header.Ccp">
                            <div class="mb-1">- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="header.Header">
                <div class="col-span-2" style="color: red;">
                    Header
                </div>
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of header.Header">
                            <div class="mb-1">- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="header.CdftAttachments">
                <div class="col-span-2" style="color: red;">
                    Attachement
                </div>
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of header.CdftAttachments">
                            <div class="mb-1">- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="errorList.xmasWellhead">
        <div class="col-span-2 text-center font-semibold">
            XMAS Tress & Wellhead
        </div>

        <ng-container *ngFor="let xmasWellhead of errorList.xmasWellhead, let i = index; ">
            <div *ngIf="!isEmpty(xmasWellhead)" class="col-span-2" style="color: red;">
                {{ valveLabels[i] }}
            </div>

            <ng-container *ngIf="xmasWellhead.Greasing">
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of xmasWellhead.Greasing">
                            <div>- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="xmasWellhead.Flushing">
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of xmasWellhead.Flushing">
                            <div>- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="xmasWellhead.Sealing">
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of xmasWellhead.Sealing">
                            <div>- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="errorList.sssv">
        <div class="col-span-2 text-center font-semibold">
            SSSV / Downhole Barrier
        </div>

        <ng-container *ngFor="let sssv of errorList.sssv">
            <ng-container *ngIf="sssv.PressureBleedOffPsi">
                <div class="col-span-2" style="color: red;">
                    Pressure bleed off
                </div>

                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of sssv.PressureBleedOffPsi">
                            <div>- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="sssv.Thp">
                <div class="col-span-2" style="color: red;">
                    Record new THP
                </div>

                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of sssv.Thp">
                            <div>- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="sssv.CyclingTest">
                <div class="col-span-2" style="color: red;">
                    Cycling Test
                </div>

                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of sssv.CyclingTest">
                            <div>- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="sssv.ClPressure">
                <div class="col-span-2" style="color: red;">
                    CL Pressure
                </div>

                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of sssv.ClPressure">
                            <div>- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="sssv.HydReturn">
                <div class="col-span-2" style="color: red;">
                    Hydraulic Return
                </div>

                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of sssv.HydReturn">
                            <div>- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </ng-container>

    </ng-container>

    <ng-container *ngIf="errorList.controlLineTest">
        <div class="col-span-2 text-center font-semibold">
            Control Line Test Report
        </div>

        <ng-container *ngFor="let ctrLine of errorList.controlLineTest, let i = index;">
            <div *ngIf="!isEmpty(ctrLine)" class="col-span-2" style="color: red;">
                {{ i == 0 ? 'Secondary Control Line' : 'Primary Control Line' }}
            </div>

            <ng-container *ngIf="ctrLine.ClInitialPressure">
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of ctrLine.ClInitialPressure">
                            <div>- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="ctrLine.ClTestedPressure">
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of ctrLine.ClTestedPressure">
                            <div>- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="ctrLine.PeriodOfTesting">
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of ctrLine.PeriodOfTesting">
                            <div>- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

        </ng-container>

    </ng-container>

    <ng-container *ngIf="errorList.subsidenceMonitoring">
        <div class="col-span-2 text-center">
            Wellhead Subsidence Monitoring Report
        </div>

        <ng-container *ngFor="let subsidenceMonitoring of errorList.subsidenceMonitoring">
            <ng-container *ngIf="subsidenceMonitoring.PcvPoint1">
                <div class="col-span-2" style="color: red;">
                    PCV
                </div>
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of subsidenceMonitoring.PcvPoint1">
                            <div class="mb-1">- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="subsidenceMonitoring.IcvPoint2">
                <div class="col-span-2" style="color: red;">
                    ICV
                </div>
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of subsidenceMonitoring.IcvPoint2">
                            <div class="mb-1">- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="subsidenceMonitoring.ScvPoint2">
                <div class="col-span-2" style="color: red;">
                    SCV
                </div>
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of subsidenceMonitoring.ScvPoint2">
                            <div class="mb-1">- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="subsidenceMonitoring.CcvPoint3">
                <div class="col-span-2" style="color: red;">
                    CCV
                </div>
                <div class="col-span-2 text-center">
                    <div class="text-left">
                        <ng-container *ngFor="let errors of subsidenceMonitoring.CcvPoint3">
                            <div class="mb-1">- {{ errors}}</div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>

</div>